<div class="box">
  <div class="modal-header">
    <button
      type="button"
      class="close pull-right"
      [title]="'CLOSE' | translate"
      [attr.aria-label]="'CLOSE' | translate"
      (click)="hide()"
    ></button>
  </div>

  <div class="modal-body">
    <div class="center">
      <div [inlineSVG]="'assets/img/icons/batch/play.svg'"></div>
      <h2 class="title">
        {{ item.name }}
        {{ 'BATCH_MAILING.BATCHES_TAB.BATCH_IS_FORMED' | translate }}
      </h2>
      @if (item.postal_delivery_type.includes('ordered_')) {
        <p class="description">
          {{ 'BATCH_MAILING.BATCHES_TAB.BLANKS_DONT_FORM_INFO' | translate }}
        </p>
      } @else {
        <p class="black-description">
          {{ 'BATCH_MAILING.BATCHES_TAB.CHECK_ADDRESS_LABELS' | translate }}
        </p>
        <p class="description">
          {{
            'BATCH_MAILING.BATCHES_TAB.PRINT_AND_SAVE_BLANKS_INFO' | translate
          }}
        </p>
      }
    </div>
  </div>

  <div class="modal-footer modal-footer--center">
    <button
      type="button"
      class="button button--outlined btn"
      (click)="close('blanks')"
    >
      {{ 'BATCH_MAILING.BLANKS_TAB.TITLE' | translate }}
    </button>

    <button
      type="button"
      class="button button--filled button--outlined btn"
      (click)="close('batches')"
    >
      {{ 'BATCH_MAILING.BATCHES_TAB.TITLE' | translate }}
    </button>
  </div>
</div>
